<template>
  <oil-form v-if="loading"
            :title="formTitle.toUpperCase()"
            :keys="keys"
            :items="company"
            :createForm="!id || !company.Id"
            :formCallback="formCallBack"
  />
</template>

<script>

import {companiesService} from '@/services/CompaniesService'
import keys from './setting/company.json'

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  data: () => ({
    formTitle: 'создать продавца',
    keys: keys,
    company: {
      AccountNumber: '',
      Address: '',
      CompanyName: '',
      ContactPerson: '',
      ContractNumbers: '',
      Manager: '',
      Phone: '+998',
      TaxNo: '',
      IsActive: '',
      HasPrivelege: '',
      Type: '',
      Comment: '',
      Dealer: '',
      VatNo: '',
      BankAddress: '',
      BankName: '',
      MFO: '',
      OKONH: '',
      OKED: '',
    },
    loading: false
  }),
  async created() {
    if (this.id) {
      this.formTitle = 'ИНФО ДАННЫХ'
      const company = await companiesService.getSellerById(this.id)

      if (!company.data) return

      this.company = company.data
    }

    this.loading = true
  },

  computed: {
    storeType() {
      return this.id ? companiesService.updateSeller : companiesService.createSeller
    }
  },
  methods: {
    /**
     * @param {Company} data
     * @param input
     */
    async formCallBack(data, input) {
      input.isEdit = false
      const store = this.storeType
      const response = await store(data)
      const id = response.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }

      this.company.Id = response.data?.Id
      this.company = response.data

      if (!this.id) {
        this.formTitle = 'обновить продавца'
        await this.$router.replace({
          name: 'seller',
          params: {id: id},
          replace: true,
        })
      }

    }
  },
  watch: {
    'company.IsActive'(name) {
      console.log(name)
    },
    'company.TaxNo'(value) {
      this.company.TaxNo = value.replace(/(\d{3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + ' ')
    }
  }
}
</script>
